// @avantia common-code
import { HpAnswerMap } from '@avantia/questionset-model';
import { getCustomFunction } from '../engineClient/customFunctionRegistry';
import { HpCreateCustomGroupHeadingFunctionProps } from '../engineClient/types';

const functionPrefix = '{{function:';

/** Resolves a `{{function:name}}` section title, heading or subheading, which the engine leaves as a raw string. */
export function resolveSectionText(text: string | null | undefined, answers: HpAnswerMap): string | null {
  if (!text || !text.startsWith(functionPrefix)) {
    return text || null;
  }

  const funcName = text.slice(functionPrefix.length, -2);
  const func = getCustomFunction('*', funcName) as (props: HpCreateCustomGroupHeadingFunctionProps) => string;
  return func({ answers } as HpCreateCustomGroupHeadingFunctionProps);
}
